import { breadcrumbAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { textStyles } from "../../../../theme/foundations/generated";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
    link: Object.assign(Object.assign({ color: "semantic.text.link" }, textStyles.body.mediumBold), { p: "2", _hover: {
            color: "semantic.text.primary",
            bgColor: "semantic.cta.secondaryHover",
        }, _focusVisible: {
            color: "semantic.text.primary",
            bgColor: "semantic.cta.secondaryHover",
            outline: "3px solid",
            outlineColor: "semantic.outline.focus",
            ":not([aria-current=page]):focus-visible": {
                boxShadow: "none",
            },
        }, _active: {
            bgColor: "semantic.cta.secondaryPressed",
            color: "semantic.text.inverse",
        }, "&[aria-current=page]": Object.assign({ color: "semantic.text.tertiary", pointerEvents: "none" }, textStyles.body.medium), textDecoration: "none" }),
});
const BreadcrumbTheme = defineMultiStyleConfig({
    baseStyle,
});
export default BreadcrumbTheme;
//# sourceMappingURL=Breadcrumb.default.js.map